import React from "react"
import styled from "styled-components"
import { Button } from "buoy-core"
import Text from "../../../../common/components/Text"
import { QuestionContainer } from "../common"
import Search from "../../../../search/components/Search"

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 1;
`

export const SubmitButton = styled(Button).attrs({
  margin: "14px 0 0",
})`
  align-self: flex-end;
`

const Custom = ({
  finished,
  custom,
  suggestionClick,
  setCustomSubmitted,
  diagnosisSearchChange,
  onBlur,
  onFocus,
  focused,
  keyDown
}) => (
  <QuestionContainer>
    <Text fontWeight="regular" marginBottom={`${custom.submitted ? 7 : 14}px`}>
      What do you think it is?
    </Text>
    {custom.submitted ? (
      <Text marginBottom="7px" color={finished ? "neutralDark" : "tertiary"}>
        {custom.diagnosis || custom.query}
      </Text>
    ) : (
      <InputContainer>
        <Search
          float
          value={custom.diagnosis || custom.query || ""}
          onFocus={onFocus}
          focused={focused}
          onBlur={onBlur}
          placeholder="Enter an illness"
          header="Closest matches:"
          onKeyDown={keyDown}
          activeSuggestion={custom.suggestions.active}
          onChange={e => diagnosisSearchChange(e.target.value, "COMPLETION_DIAGNOSIS_FEEDBACK")}
          search={custom.query || custom.diagnosis || ""}
          suggestions={custom.suggestions.items}
          suggestionClick={suggestionClick}
          searchClear={() => diagnosisSearchChange("")}
        />
        <SubmitButton
          disabled={!(custom.diagnosis || custom.query) || finished}
          onClick={() => setCustomSubmitted(true)}
        >Submit</SubmitButton>
      </InputContainer>
    )}
  </QuestionContainer>
)

class CustomContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      focused: false,
    }
  }

  keyDown = e => {
    let key = e.keyCode || e.which
    if (key === 38) {
      e.preventDefault()
      e.stopPropagation()
      this.props.decrementDiagnosisSuggestions()
    } else if (key === 40) {
      e.preventDefault()
      e.stopPropagation()
      this.props.incrementDiagnosisSuggestions()
    } else if (key === 13) {
      if (this.props.custom.suggestions.active > -1) {
        e.preventDefault()
        e.stopPropagation()
        this.props.selectActiveSuggestion()
      }
    }
  }

  onFocus = () => {
    this.setState({ focused: true })
  }

  onBlur = () => {
    this.setState({ focused: false })
  }

  render() {
    return (
      <Custom
        {...this.props}
        focused={this.state.focused}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        keyDown={this.keyDown}
      />
    )
  }
}

export default CustomContainer



// WEBPACK FOOTER //
// ./assets/feedback/components/tagging/components/Custom.js